import React from 'react';

export const AddIcon = () => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z'
				fill='#009E69'
			/>
			<path
				d='M13.5 9.5C12.9 9.5 10.5 9.5 10.5 9.5C10.5 9.5 10.5 7.1 10.5 6.5C10.5 6.2 10.3 6 10 6C9.7 6 9.5 6.2 9.5 6.5C9.5 7.1 9.5 9.5 9.5 9.5C9.5 9.5 7.1 9.5 6.5 9.5C6.2 9.5 6 9.7 6 10C6 10.3 6.2 10.5 6.5 10.5C7.1 10.5 9.5 10.5 9.5 10.5C9.5 10.5 9.5 12.9 9.5 13.5C9.5 13.8 9.7 14 10 14C10.3 14 10.5 13.8 10.5 13.5C10.5 12.9 10.5 10.5 10.5 10.5C10.5 10.5 12.9 10.5 13.5 10.5C13.8 10.5 14 10.3 14 10C14 9.7 13.8 9.5 13.5 9.5Z'
				fill='white'
			/>
		</svg>
	);
};
